import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import getRequestParams from '@/helpers/getRequestParams.js'

export const useCarAreasStore = defineStore('car-areas', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()

    const carAreas           = ref({})
    const carAreasProcess    = ref(false)
    const carAreasMsg        = ref({})

    const carAreasByAreaProcess = ref(false)
    const carAreasByAreaMsg     = ref({})

    const carAreasCreateProcess = ref(false)
    const carAreasCreateMsg     = ref({})

    const carAreasDeleteProcess = ref(false)
    const carAreasDeleteMsg     = ref({})

    async function createCarArea(payload) {

        const token = tokenStore.access

        if(token) {
            carAreasCreateProcess.value = true

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                carAreasCreateMsg.value = { success: true, text: 'CAR_AREAS_CREATE_SUCCESS' }
            } else {
                carAreasCreateMsg.value = { success: false, text: request.error }
            }

            carAreasCreateProcess.value = false
        } else {
            carAreasCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }        
    }

    async function readCarAreas(payload, isUseStore) {

        const token = tokenStore.access
        let result = {}

        if(token) {
            carAreasProcess.value = true
            
            let params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                result = request

                if (isUseStore) carAreas.value = request

                carAreasMsg.value = { success: true }

            } else {
                if (isUseStore) carAreas.value = {}
                carAreasMsg.value = { success: false, text: request.error }
            }

            carAreasProcess.value = false
        } else {

            carAreasMsg.value = { success: false, text: 'EUnauthRequest' }
        }
        
        return result
    }

    async function readCarAreasByArea(payload) {
        const token = tokenStore.access
        let result = {}

        if(token) {
            carAreasByAreaProcess.value = true

            let params = ''

            if(payload) {
                for(let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                result = request
                carAreasByAreaMsg.value = { success: true }

            } else {
                carAreasByAreaMsg.value = { success: false, text: request.error }
            }

            carAreasByAreaProcess.value = false
        } else {
            carAreasByAreaMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        return result
    }

    async function deleteCarArea(uuid) {
        const token = tokenStore.access

        if(token) {

            if(uuid) {
                carAreasDeleteProcess.value = true

                const request = await requestsStore.fetchRequest({
                    address: `${configStore.httpServer}/cars/events/params/${uuid}`, 
                    method: 'DELETE', 
                    token
                })
    
                if(!request.error) {

                    carAreasDeleteMsg.value = { success: true, text: 'CAR_AREAS_DELETE_SUCCESS' }
                } else {

                    carAreasDeleteMsg.value = { success: false, text: request.error }
                }

                carAreasDeleteProcess.value = false
            } else {
                carAreasDeleteMsg.value = { success: false, text: 'CAR_AREAS_UUID_NOT_FOUND' }
            }
            
        } else {
            carAreasDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }        
    }

    const setCarAreasMsg = data => carAreasMsg.value = data
    const setCarAreasCreateMsg = data => carAreasCreateMsg.value = data
    const setCarAreasDeleteMsg = data => carAreasDeleteMsg.value = data

    return {
        carAreas,
        carAreasProcess,
        carAreasMsg,
        carAreasByAreaProcess,
        carAreasByAreaMsg,
        carAreasCreateProcess,
        carAreasCreateMsg,
        carAreasDeleteProcess,
        carAreasDeleteMsg,
        createCarArea,
        readCarAreas,
        readCarAreasByArea,
        deleteCarArea,
        setCarAreasMsg,
        setCarAreasCreateMsg,
        setCarAreasDeleteMsg
    }
})
